import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { H2 } from 'components/common/Text/Text'

// change flex-direction to column for grid mode
export const Content = styled.div`
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  ${Mixin.responsive('padding', '0', '0 7px')}
  ${Media.desktop`
    margin-top: 51px;
    flex-direction: ${props => props.useFlex ? 'row' : 'column'};
  `}
`

export const Wrapper = styled.div`
  flex: 1 1 auto;
  ${Media.mobile`
    &:not(:first-of-type) {
        margin-top: 40px;
    }
  `}
`

export const Heading = styled(H2)`
  text-transform: uppercase;
  ${Mixin.responsive('margin', '0 0 30px', '13px 0 13px')}
  ${Mixin.font.GothamBold(26)}
  ${Media.mobile`
    ${Mixin.font.GothamBold(14)}
  `}
`
